import * as React from 'react';
import NavbarPortal from 'src/containers/NavbarPortal';
import i18n from 'src/resources/i18n';

import ExerciseFormContainer from '../../containers/ExerciseForm';
/**
 * 課題提出画面
 * @param props
 */
const ExerciseFormPortal: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const seq = props.match.params.seq;
	const flg = props.match.params.flg;
	const subjectStatusflg = props.match.params.subjectStatusflg;

	return (
		<>
			<NavbarPortal title={i18n.t('ExerciseForm_0014')} />
			<ExerciseFormContainer
				careerID={careerID}
				classID={classID}
				seq={seq}
				outOfPeriodFlg={false}
				preview={false}
				flg={flg}
				subjectStatusflg={subjectStatusflg}
			/>
		</>
	);
};

export default ExerciseFormPortal;



// WEBPACK FOOTER //
// ./src/pages/personal/ExerciseFormPortal.tsx